import * as React from 'react';
import './Appear.style.scss';

interface AppearProps {
  delay?: number;
  duration?: number;
  className?: string;
}
const Appear: React.SFC<AppearProps> = (props) => {
  const { delay = 0, duration = .5, children, className = '' } = props;
  const style = {
    '--delay': `${delay}s`,
    '--duration': `${duration}s`
  } as React.CSSProperties;
  return (
    <div
      className={`Appear__item ${className}`}
      style={style}
    >
      {children}
    </div>
  )
}
export default Appear;